import { render } from "./Icone.vue?vue&type=template&id=58f12ef1&ts=true"
import script from "./Icone.vue?vue&type=script&lang=ts"
export * from "./Icone.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__